import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchFirstPageSearchEntriesRequestAction, setSearchWorkingAction } from '../../data/actions/search';
import { Btn, Bx, IconBtn, Typo, useBreakpoints } from '@curry-group/mui-curcuma';
import clsx from 'clsx';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm'
import { Skeleton } from '@material-ui/lab';
import { faLightbulbOn, faMessageBot, faRedo } from '@fortawesome/pro-light-svg-icons';
import useTheme from '@material-ui/core/styles/useTheme';
import { debounce as _debounce } from 'lodash';
import { botResponseEndAction, fetchBotExpertAnswerRequestAction, trackBotFeedbackAction } from '../../data/actions/bot';
import { setFlowAnonymousAction, setFlowDataAction, setFlowTypeAction } from '../../data/actions/flow';
import { NewQnAEntry } from '../widget/forum-popup/new-qna-entry';
import { IMemoryListItem, transformForList } from '../../model/ryve/Thing';
import { ListWidget } from '../widget/list';
import { userprofileMemorylistRequestAction } from '../../data/actions/foundation';
import { useHistory } from 'react-router';
import { Grid } from '@material-ui/core';

export interface IBotSearchResultProps {
  alias: string;
  working?: boolean;
  isMobile?: boolean;
}

const useStyles = makeStyles(theme => ({
  markdown: {
    '& > *:first-child': {
      marginTop: 0
    },
    '& pre': {
      whiteSpace: 'pre-wrap',
      wordWrap: 'break-word'
    }
  }
}));

export const BotSearchResults: React.FC<IBotSearchResultProps> = ({
  alias,
  working,
  isMobile = false
}) => {
  const history = useHistory();
  const theme = useTheme();
  const dispatch = useDispatch();
  const classes = useStyles();
  const botAnswer = useSelector(state => state.bot?.botSearch?.botAnswer);
  // const botExpertAnswer = useSelector(state => state.bot?.botSearch?.botExpertAnswer);
  // const botWorking = useSelector(state => state.bot?.botSearch?.botWorking);
  const botRequestId = useSelector(state => state.bot?.botSearch?.botRequestId);
  const botFeedback = useSelector(state => state.bot?.botSearch?.botFeedback);
  const positiveFeedback = useSelector(state => state.filter?.filterItem?.content?.positiveFeedback);
  const negativeFeedback = useSelector(state => state.filter?.filterItem?.content?.negativeFeedback);
  const botPreText = useSelector(state => state.filter?.filterItem?.content?.botPreText);
  const botPostText = useSelector(state => state.filter?.filterItem?.content?.botPostText);
  const queryTerm = useSelector(state => state.filter?.searchObject?.queryTerm);
  const automaticSearch = useSelector(state => state.bot?.automaticSearch);
  const answerCategories = useSelector(state => state.search?.result?.answer_categories);
  // const memoryItems = useSelector(state => state.foundation?.profile?.memoryList);
  const [newQnAEntryOpen, setNewQnAEntryOpen] = useState<boolean>(false);

  let feedbackItems: Array<{name:string; pos:boolean;}> = [];
  if (!!positiveFeedback && positiveFeedback.length > 0) {
    feedbackItems = [...feedbackItems, ...positiveFeedback.map((item: { name: string; }) => ({name: item.name, pos:true}))];
  }
  if (!!negativeFeedback && negativeFeedback.length > 0) {
    feedbackItems = [...feedbackItems, ...negativeFeedback.map((item: { name: string; }) => ({name: item.name, pos:false}))];
  }
  // const memoryIds = memoryItems?.map(m => m.typeId === m.elementId);
  
  const dispatcher = {
    debouncedFetchFirstPageSearchEntries: _debounce(() => {
      dispatch(fetchFirstPageSearchEntriesRequestAction?.({}));
    }, 350),
    debouncedFetchBotExpertAnswerRequest: _debounce(() => {
      dispatch(fetchBotExpertAnswerRequestAction?.({}));
    }, 350),
    setSearchWorking: (working: boolean) => dispatch(setSearchWorkingAction({ working })),
    trackBotFeedback: (botRequestId: string, feedback: string, rating: number, queryTerm?: string) => {
      dispatch(trackBotFeedbackAction?.({ botRequestId, feedback, rating, queryTerm }));
    },
    setBotResponseAction: (botAnswer: string, botRequestId: string) => dispatch(botResponseEndAction?.({response: botAnswer, request_id: botRequestId})),
    setQnaFlowQuestionAction: (query: string, botAnswer: string, answerCategories: Array<string>) => dispatch(setFlowDataAction({
      alias: 'forum',
      flowData: {
        noFlow: true,
        itemData: {
          title: query,
          botAnswer: botAnswer,
          answerCategories: answerCategories
        }
      }
    })),
    setQnaFlowInitAction: () => {
      dispatch(setFlowTypeAction({type: 'qna'}));
      dispatch(setFlowAnonymousAction({anonymous: false}));
    },
    itemMemoryClicked: (item: IMemoryListItem, type: 'GET'|'POST'|'DELETE') => dispatch(userprofileMemorylistRequestAction({
      memoryItem: item,
      type: type
    })),
    shareClick: (detailItem) => {
      dispatch(setFlowDataAction({
        alias: 'share',
        flowData: {
          location: history.location,
          itemData: { sharedItem: detailItem }
        }
      }));
      history.push(history.location.pathname + '/flow' + history.location.search);
    }
  };

  let botText = botPreText || 'Geben Sie oben eine fachliche Frage ein und schicken Sie Ihre Anfrage per Eingabe-Taste (ENTER) oder den blauen Button ab für eine KI-gestützte Zusammenfassung. Geben Sie ansonsten ein Thema ein zu dem Sie passende Magazinbeiträge erhalten möchten und drücken Sie auf den grünen Button für eine gefilterte Suche.';
  if (alias === 'experts-actors') {
    botText = botPreText || 'Geben Sie oben eine fachliche Frage ein und schicken Sie Ihre Anfrage per Eingabe-Taste (ENTER) oder den blauen Button ab. Unser Bot sucht anhand der Beiträge im Magazin nach Expertinnen und Experten für Sie.';
  }

  // if (alias === 'experts-actors') {
  //   return (
  //     <>
  //       <Bx
  //         style={{
  //           border: '1px solid transparent',
  //           borderRadius: 16,
  //           background:'rgb(230, 245, 251)',
  //           padding:'16px'
  //         }}
  //       >
  //         <Grid item xs={12}>
  //         <Bx display="flex"
  //           flexDirection={isMobile ? 'column' : 'row'}
  //           pb={botExpertAnswer?.hits?.total > 0 ? 2 : 0}>
  //           <Bx pr={2}>
  //             <Typo variant="h1" component="p">
  //               <FontAwesomeIcon icon={faMessageBot} />
  //             </Typo>
  //           </Bx>
  //           <Bx >
  //             {(!working && !botExpertAnswer) && <Typo variant="body1" component="p" style={{width:'100%',marginTop:'8px'}}>
  //               {botText}
  //               </Typo>}
  //             {(working && !botExpertAnswer) && <Typo variant="body1" component="p" style={{width:'100%',marginTop:'8px'}}>
  //               <Skeleton animation="pulse" width="16px" style={{display:'inline-block'}} />
  //               &nbsp;
  //               <Skeleton animation="pulse" width="16px" style={{display:'inline-block'}} />
  //               &nbsp;
  //               <Skeleton animation="pulse" width="16px" style={{display:'inline-block'}} />
  //             </Typo>}
  //             {!!botExpertAnswer && <Typo variant="body1" component="p" style={{width:'100%',marginTop:'8px'}}>
  //               {botExpertAnswer?.hits?.total > 0
  //                 ? `Verfügbare Experten (${botExpertAnswer.hits.total})`
  //                 : 'Keine Experten gefunden'}
  //             </Typo>}
  //           </Bx>
  //         </Bx>
  //         </Grid>
  //         {!!botExpertAnswer && <Grid item xs={12}>
  //           <ListWidget
  //             working={botWorking}
  //             items={transformForList(botExpertAnswer?.hits?.hits.map(hit => {
  //               return {
  //                 ...hit,
  //                 booked: memoryIds?.includes(hit._id),
  //                 noShare: false
  //               };
  //             }))}
  //             headline={undefined}
  //             itemMemoClicked={dispatcher.itemMemoryClicked}
  //             shareClick={dispatcher.shareClick}
  //           />
  //         </Grid>}
  //       </Bx>
  //       {botRequestId &&
  //       <Bx my={2} display={'flex'}
  //           style={{
  //             flexDirection: 'row',
  //             flexWrap: 'wrap'
  //           }}
  //         >
  //         <Bx>
  //           <IconBtn
  //             onClick={() => {
  //               dispatcher.setSearchWorking?.(true);
  //               dispatcher.setBotResponseAction?.('', '');
  //               dispatcher.debouncedFetchBotExpertAnswerRequest?.();
  //             }}
  //             size="small"
  //           >
  //             <FontAwesomeIcon icon={faRedo} />
  //           </IconBtn>
  //         </Bx>
  //         {/* {botAnswer && !!feedbackItems && feedbackItems.length > 0 && feedbackItems.map((item, index) => { */}
  //         {!!feedbackItems && feedbackItems.length > 0 && feedbackItems.map((item, index) => {
  //           const itemColor = item.pos
  //             ? theme.palette.secondary.main
  //             : theme.palette.error.main;
  //           return (
  //             <Bx
  //             key={`BOT_FEEDBACK_ITEM_${index}`}
  //               display="flex"
  //               justifyContent="center"
  //               alignItems="center"
  //               minWidth={36}
  //               px={1.5}
  //               py={.5}
  //               ml={1}
  //               mb={1}
  //               style={{
  //                 cursor:'pointer',
  //                 borderRadius:8,
  //                 border:`1px solid ${botFeedback === item.name ? 'transparent' : itemColor}`,
  //                 background: botFeedback === item.name ? itemColor : 'transparent',
  //                 color: botFeedback === item.name ? 'white' : itemColor
  //               }}
  //               onClick={() => {
  //                 dispatcher.trackBotFeedback?.(botRequestId || '', item.name, 1, queryTerm);
  //               }}
  //             >
  //               <Typo
  //                 style={{
  //                   wordBreak:'keep-all'
  //                 }}
  //                 variant="body1"
  //               >{item.name}</Typo>
  //             </Bx>
  //         )})}
  //         {!!botFeedback && <Bx
  //           key={`BOT_FEEDBACK_ITEM_FEELGOOD_${feedbackItems.length + 1}`}
  //           display="flex"
  //           justifyContent="center"
  //           alignItems="center"
  //           minWidth={36}
  //           px={1.5}
  //           py={.5}
  //           ml={1}
  //           mb={1}
  //         >
  //           <Typo style={{wordBreak:'keep-all'}}variant="body1">{'Danke für Ihr Feedback!'}</Typo>
  //         </Bx>}
  //         {botAnswer &&
  //           <Bx display="flex"
  //             flexDirection={isMobile ? 'column' : 'row'}
  //             style={{
  //               border: '1px solid transparent',
  //               borderRadius:16,
  //               background:'rgb(230, 245, 251)',
  //               padding:'16px'
  //             }}
  //             mt={1}
  //             mb={2}
  //           >
  //           <Bx pr={2}>
  //             <Typo variant="h1" component="p">
  //               <FontAwesomeIcon icon={faMessageBot} />
  //             </Typo>
  //           </Bx>
  //           <Bx>
  //             <Typo variant="body1" component="p" style={{width:'100%',marginTop:'8px'}}>
  //               {botPostText || 'Geben Sie uns Feedback zur Antwort über die grünen und roten Buttons. Wenn Sie Nachfragen haben, geben Sie einen angepassten Input ein und drücken Sie erneut den blauen Button oder die Eingabe-Taste (ENTER)'}
  //             </Typo>
  //           </Bx>
  //         </Bx>}
  //       </Bx>
  //     }
  //     </>
  //   );
  // }

  return (
    <>
      <NewQnAEntry newQnAEntryOpen={newQnAEntryOpen} close={() => setNewQnAEntryOpen(false)} cancel={() => setNewQnAEntryOpen(false)}/>
      <Bx display="flex"
        flexDirection={isMobile ? 'column' : 'row'}
        style={{
          border: '1px solid transparent',
          borderRadius: 16,
          background:'rgb(230, 245, 251)',
          padding:'16px'
        }}
        mb={!botRequestId ? 2 : 0}
      >
        <Bx pr={2}>
          <Typo variant="h1" component="p">
            <FontAwesomeIcon icon={faMessageBot} />
          </Typo>
        </Bx>
        <Bx>
          {(!working && !botAnswer && !automaticSearch) && <Typo variant="body1" component="p" style={{width:'100%',marginTop:'8px'}}>
            {botText}
            </Typo>}
          {((working || automaticSearch) && !botAnswer) && <Typo variant="body1" component="p" style={{width:'100%',marginTop:'8px'}}>
            <Skeleton animation="pulse" width="16px" style={{display:'inline-block'}} />
            &nbsp;
            <Skeleton animation="pulse" width="16px" style={{display:'inline-block'}} />
            &nbsp;
            <Skeleton animation="pulse" width="16px" style={{display:'inline-block'}} />
          </Typo>}
          {!!botAnswer && <Markdown className={clsx(classes.markdown)} remarkPlugins={[remarkGfm]} linkTarget="_blank">{(botAnswer ?? '')}</Markdown>}
        </Bx>
      </Bx>
      {/* {true && */}
      {botRequestId &&
        <Bx my={2} display={'flex'}
          style={{
            flexDirection: 'row',
            flexWrap: 'wrap'
          }}
        >
        <Bx>
          <IconBtn
            onClick={() => {
              dispatcher.setSearchWorking?.(true);
              dispatcher.setBotResponseAction?.('', '');
              dispatcher.debouncedFetchFirstPageSearchEntries?.();
            }}
            size="small"
          >
            <FontAwesomeIcon icon={faRedo} />
          </IconBtn>
        </Bx>
        {/* {botAnswer && !!feedbackItems && feedbackItems.length > 0 && feedbackItems.map((item, index) => { */}
        {!!feedbackItems && feedbackItems.length > 0 && feedbackItems.map((item, index) => {
          const itemColor = item.pos
            ? theme.palette.secondary.main
            : theme.palette.error.main;
          return (
            <Bx
            key={`BOT_FEEDBACK_ITEM_${index}`}
              display="flex"
              justifyContent="center"
              alignItems="center"
              minWidth={36}
              px={1.5}
              py={.5}
              ml={1}
              mb={1}
              style={{
                cursor:'pointer',
                borderRadius:8,
                border:`1px solid ${botFeedback === item.name ? 'transparent' : itemColor}`,
                background: botFeedback === item.name ? itemColor : 'transparent',
                color: botFeedback === item.name ? 'white' : itemColor
              }}
              onClick={() => {
                dispatcher.trackBotFeedback?.(botRequestId || '', item.name, 1, queryTerm);
              }}
            >
              <Typo
                style={{
                  wordBreak:'keep-all'
                }}
                variant="body1"
              >{item.name}</Typo>
            </Bx>
        )})}
        {!!botFeedback && <Bx
          key={`BOT_FEEDBACK_ITEM_FEELGOOD_${feedbackItems.length + 1}`}
          display="flex"
          justifyContent="center"
          alignItems="center"
          minWidth={36}
          px={1.5}
          py={.5}
          ml={1}
          mb={1}
        >
          <Typo style={{wordBreak:'keep-all'}}variant="body1">{'Danke für Ihr Feedback!'}</Typo>
        </Bx>}
        {alias !== 'experts-actors' && <Bx ml={'auto'}>
          <Btn
            size="large"
            startIcon={<FontAwesomeIcon icon={faLightbulbOn} />}
            onClick={() => {
              dispatcher.setQnaFlowQuestionAction?.(
                queryTerm || '',
                botAnswer || '',
                answerCategories || []
              );
              dispatcher.setQnaFlowInitAction?.();
              setNewQnAEntryOpen(true);
            }}
            color={'secondary'}
            variant={'contained'}
            title='Hier können Sie Ihre Frage an das Forum stellen.'
          >
            {'Ans Forum wenden'}
          </Btn>
        </Bx>}
      </Bx>}
      {botAnswer &&
        <Bx display="flex"
          flexDirection={isMobile ? 'column' : 'row'}
          style={{
            border: '1px solid transparent',
            borderRadius:16,
            background:'rgb(230, 245, 251)',
            padding:'16px'
          }}
          mt={1}
          mb={2}
        >
        <Bx pr={2}>
          <Typo variant="h1" component="p">
            <FontAwesomeIcon icon={faMessageBot} />
          </Typo>
        </Bx>
        <Bx>
          <Typo variant="body1" component="p" style={{width:'100%',marginTop:'8px'}}>
            {botPostText || 'Geben Sie uns Feedback zur Antwort über die grünen und roten Buttons. Wenn Sie Nachfragen haben, geben Sie einen angepassten Input ein und drücken Sie erneut den blauen Button oder die Eingabe-Taste (ENTER)'}
          </Typo>
        </Bx>
      </Bx>}
    </>
  );
};

export const ConnectedBotSearchResults: React.FC<{alias: string}> = ({alias}) => {
  const isMobile = !!useBreakpoints().mdDown;
  const working = useSelector(state => state.search?.working);

  return (
    <BotSearchResults
      alias={alias}
      working={working}
      isMobile={isMobile}
    />
  );
};
